import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-virtual-keyboard',
	templateUrl: './virtual-keyboard.component.html',
	styleUrls: ['./virtual-keyboard.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class VirtualKeyboardComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/virtual-keyboard/virtual-keyboard.component.ts